module.exports = __webpack_public_path__ + "static/image/history/m/202305@3x.jpg?1566719f";